var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M255.73 383.71c70.3 0 127.3-56.99 127.3-127.3s-56.99-127.3-127.3-127.3-127.3 56.99-127.3 127.3 56.99 127.3 127.3 127.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 283.285,
    y1: 18.901,
    x2: 62.826,
    y2: 400.747,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1e8e3e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#34a853"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__a)",
    d: "M145.48 320.08 35.26 129.17a254.524 254.524 0 0 0 93.19 347.75A254.548 254.548 0 0 0 255.75 511l110.22-190.92v-.03a127.239 127.239 0 0 1-46.58 46.62c-19.35 11.18-41.3 17.07-63.65 17.07s-44.3-5.88-63.66-17.05a127.19 127.19 0 0 1-46.6-46.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 218.59,
    y1: 2.333,
    x2: 439.049,
    y2: 384.18,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fcc934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fbbc04"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__b)",
    d: "M365.96 320.08 255.74 510.99c44.69.01 88.59-11.75 127.29-34.1a254.52 254.52 0 0 0 93.13-347.76H255.72l-.03.02c22.35-.01 44.31 5.86 63.66 17.03a127.314 127.314 0 0 1 46.61 46.59 127.252 127.252 0 0 1 17.06 63.66c.01 22.34-5.88 44.29-17.06 63.65z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M255.73 357.21c55.66 0 100.78-45.12 100.78-100.78s-45.12-100.78-100.78-100.78-100.78 45.12-100.78 100.78 45.12 100.78 100.78 100.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 35.259,
    y1: 353.03,
    x2: 476.177,
    y2: 353.03,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d93025"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ea4335"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chrome_svg__c)",
    d: "M255.73 129.14h220.45A254.472 254.472 0 0 0 383 35.95a254.524 254.524 0 0 0-347.74 93.21l110.22 190.92.03.02c-11.18-19.35-17.08-41.3-17.08-63.65s5.87-44.31 17.04-63.66a127.164 127.164 0 0 1 46.6-46.6 127.14 127.14 0 0 1 63.66-17.05z"
  })));
};
export default SvgChrome;